import React from 'react'
import styled from 'styled-components'
import Form, { useFormContext } from '@jarvis.oddle/core/components/Form'
import Div from '@jarvis.oddle/core/components/Div'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import {
  colorConstants,
  colors,
  padding,
  paddingSizes
} from '@jarvis.oddle/core/theme/default'
import CreditCardInput from 'react-credit-card-input'

const CreditCardInputContainer = styled(Div)`
  #field-wrapper {
    border: 1px
      ${(props) =>
        props.isError
          ? colorConstants.red
          : props.isFocus
          ? colors.text
          : colors.separator}
      solid;
    padding: ${padding[paddingSizes.medium]} ${padding[paddingSizes.small]};
    background-color: ${colorConstants.white};

    > label:first-of-type {
      flex-grow: 1;
    }

    input::placeholder {
      color: ${colors.disabled};
    }
  }
`

const containerStyle = { width: '100%' }
const dangerTextStyle = { display: 'none' } // Use FormError to show error message

const _CreditCardInput = (): JSX.Element => {
  const { t } = React.useContext(TranslationContext)
  const { values, setFieldValue, setFieldTouched, errors, touched } =
    useFormContext()
  const [isFocus, setIsFocus] = React.useState(false)

  const getInputProps = (name) => ({
    onChange: (e) => {
      setFieldValue('card', { ...values.card, [name]: e.target.value }, true)
      setFieldTouched('card', true)
    },
    onFocus: () => setIsFocus(true),
    onBlur: () => setIsFocus(false),
    name
  })

  const isError = touched.card && errors.card
  return (
    <Div>
      <Form.Input name='cardName' label={t('Name on Card')} />
      <CreditCardInputContainer isFocus={isFocus} isError={isError}>
        <CreditCardInput
          containerStyle={containerStyle}
          dangerTextStyle={dangerTextStyle}
          customTextLabels={{
            expiryError: {},
            cardNumberPlaceholder: t('Card Number'),
            cvcPlaceholder: t('CCV')
          }}
          cardNumberInputProps={getInputProps('cardNumber')}
          cardExpiryInputProps={getInputProps('cardExpiry')}
          cardCVCInputProps={getInputProps('cvc')}
        />
      </CreditCardInputContainer>
    </Div>
  )
}

export default _CreditCardInput
